import {
	engagementsApi,
	getTaskFromCache,
	normalizeTaskForCache,
} from '@/features/engagements/engagementsApi';
import React, { useEffect } from 'react';
import { useInstantSearch } from 'react-instantsearch';
import { useDispatch, useSelector, useStore } from 'react-redux';

const INTERVAL = 5 * 60 * 1000; // 5 minutes

export const TableRefresh = ({ table = '', interval = INTERVAL }) => {
	const dispatch = useDispatch();
	const store = useStore();
	const { refresh, results } = useInstantSearch();

	const refreshIndicator = useSelector((state) => state[table]?.refreshIndicator);

	useEffect(() => {
		if (table !== 'taskTable' || !results?.hits) {
			return;
		}

		for (const hit of results.hits) {
			const taskId = hit.id ?? hit.hubspotId;
			if (!taskId || getTaskFromCache(store.getState(), taskId)) {
				continue;
			}

			dispatch(
				engagementsApi.util.upsertQueryData(
					'getTask',
					taskId,
					normalizeTaskForCache(hit),
				),
			);
		}
	}, [dispatch, results?.hits, store, table]);

	useEffect(() => {
		console.log(`${table} REFRESH INDICATOR`, refreshIndicator);

		setTimeout(() => {
			try {
				if (typeof refresh == 'function') refresh();
			} catch (e) {
				console.warn('Error refreshing table state', e);
			}
		}, 100);
	}, [refreshIndicator, table, refresh]);

	// Add periodic refresh
	useEffect(() => {
		const id = setInterval(() => {
			try {
				if (typeof refresh == 'function') refresh();
			} catch (e) {
				console.warn('Error refreshing table state', e);
			}
		}, interval);

		return () => clearInterval(id);
	}, [refresh, interval]);

	return null;
};

TableRefresh.displayName = 'TableRefresh';
